<template>
	<div class="symptom analysis">
		<div class="questions card">
			<h5>Analysis</h5>

			<el-row :gutter="10">
				<el-col :span="12" v-for="n in 2">
					<AnalysisResponse
						v-for="(question, i) in symptom.question"
						v-if="i % 2 == (n - 1)"
						:key="question.id"
						:question="question"
						v-bind:analysis="analysis">
					</AnalysisResponse>
				</el-col>
			</el-row>
		</div>

		<div class="values card table">
			<h5>Records</h5>
			<el-table
				:data="orderedSymptoms"
				max-height="300px">
				<el-table-column label="Date" width="110">
					<template slot-scope="scope">
						<strong class="date">{{ formatDate(scope.row.time) }}</strong>
					</template>
				</el-table-column>
				<el-table-column
					v-for="question in symptom.question"
					:key="question.id"
			        :label="question.title"
					:width="(question.type == 'slider') ? 100 : 200">
					<template slot-scope="scope">
						<div class="response">
							<span v-for="(response, index) in displayResponse(question, scope.row)" :key="index">
								{{ response }}
								<span v-if=""></span>
							</span>
						</div>
					</template>
			      </el-table-column>
			</el-table>
		</div>
	</div>
</template>

<script>
import CardAnalysis from '../../component/analysis'
import AnalysisResponse from './Response'
import BODYMAP from '../../../../util/get-bodymap'

export default {
	name: 'symptom-card-analysis',
	extends: CardAnalysis,

	props: {
		symptoms: {
			type: Array
		},
		id: {
			type: String,
			required: true
		}
	},

	methods: {
		getResponse(questionContent, symptom) {
			return symptom.question.find((questionResponse) => {
				return questionResponse.id == questionContent.id
			})
		},
		displayResponse(questionContent, symptom) {
			var response = this.getResponse(questionContent, symptom)
			if (response) {
				if (Array.isArray(response.option)) {
					if(questionContent.type === 'human_map')
						return response.option.map((bodypart) =>  BODYMAP[bodypart].name)
					return response.option
				}
				else if (response.value)
					return [ response.value ]
			}
		}
	},

	computed: {
		symptom() {
			return this.getContent('symptom', this.id)
		},

		orderedSymptoms() {
			return this.symptoms.slice().sort((a, b) => (b.time - a.time))
		},

		analysis() {
			// title -> array of answers
			var analysis = {}
			if (this.symptom && this.symptoms) {
				// For each question in the content object
				this.symptom.question.forEach((questionContent) => {
					let qa = {}

					// For each symptom
					this.symptoms.forEach((s) => {
						// Find the question corresponding to this content question
						let q = this.getResponse(questionContent, s)
						//
						if (q) {
							if (Array.isArray(q.option)) {
								q.option.forEach((o) => {
									qa[o] = (qa[o]) ? (qa[o] + 1) : 1
								})
							}
							else if (q.value) {
								qa[q.value] = (qa[q.value]) ? (qa[q.value] + 1) : 1
							}
						}
					})

					analysis[questionContent.title] = Object.keys(qa)
						.sort((a, b) => (qa[b] - qa[a]))
						.map((k) => ({ key: k, value: qa[k] }))
				})
			}
			return analysis
		}
	},

	components: {
		AnalysisResponse
	}
}
</script>

<style lang="scss" scoped>
@import "../../component/table/style/analysis.scss";

h3 {
	font-size: 16px;
	padding: 5px 15px;
}

.values {
	.response {
		line-height: 16px;
		word-break: normal;
	}
}
</style>
